mutation UpdateUsDueDiligence($input: UpdateUsDueDiligenceInput!) {
  updateUsDueDiligence(input: $input) {
    usDueDiligence {
      id
    }
  }
}
